import FormOverviewPage from '@/views/forms/FormOverviewPage'
import FormLayout from '@/views/layouts/FormLayout'

export default function Form() {
  return (
    <FormLayout>
      <FormOverviewPage />
    </FormLayout>
  )
}
